import ServerModel from '../../models/SystemConfiguration/ServerModel';
import BaseStore from '../BaseStore';

class ServerStore extends BaseStore {
  constructor(transportLayer) {
    super(ServerModel, transportLayer);
  }

  sync(id) {
    return this.transportLayer.syncServer(id);
  }
}

export default ServerStore;



// WEBPACK FOOTER //
// ./src/stores/SystemConfiguration/ServerStore.js